import ButtonOptions from "%/dynamic-components/render-engine/bundles/button-options";
import ButtonType from "%/dynamic-components/render-engine/options/button-options/button-type";
import ButtonSize from "%/dynamic-components/render-engine/options/button-options/button-size";
import Icon from "%/dynamic-components/render-engine/options/icon-options/icon";
import IconPosition from "%/dynamic-components/render-engine/options/icon-options/icon-position";
import TextAlignment from "%/dynamic-components/render-engine/options/button-options/text-alignment";
import ButtonAction from "%/dynamic-components/render-engine/options/button-options/button-action";
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import BasicTextOptions from "%/dynamic-components/render-engine/bundles/basic-text-options";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import PositioningOptions from "%/dynamic-components/render-engine/bundles/positioning-options";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import BorderRadius from "%/dynamic-components/render-engine/options/border-options/border-radius";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import TextOptions from "%/dynamic-components/render-engine/bundles/text-options";
import AnimationsOptions from "%/dynamic-components/render-engine/bundles/animations-options";
import LinkType from "%/dynamic-components/render-engine/options/link-type";
import {
  TextWithoutBrandingElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/text-element/text-without-branding-element-mixin";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";
import {
  SharedButtonComputedStylesMixin,
} from "%/dynamic-components/render-engine/components/production/elements/button-element/shared-button-computed-styles-mixin";
import ButtonBranding from "%/dynamic-components/render-engine/classes/branding/button-branding";
import ButtonBorderOptions from "%/dynamic-components/render-engine/bundles/button-border-options";

export const ButtonElementMixin = {
  elementPanelSettings: {
    displayIcon: "message",
    elementType: "element",
  },
  brandingType: ButtonBranding,
  mixins: [TextWithoutBrandingElementMixin, DynamicElementMixin, SharedButtonComputedStylesMixin],
  props: {
    handleCustomClick: {
      type: Function,
      required: false,
      default: null,
    },
  },
  optionsOrder: [
    "button",
    "click-action",
  ],
  optionBundles: [
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    PositioningOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "hug",
      "default.layout-height": "hug",
    }),
    new AppearanceOptions({
      "default.border-radius": "large",
    }, {
      "border-radius": false,
    }),
    AnimationsOptions,
    new ButtonOptions({ "default.icon": "" }),
    ButtonBorderOptions,
    new SpacingOptions({
      "default.padding": {
        "top": null,
        "left": null,
        "bottom": null,
        "right": null,
      },
    }),
    new BasicTextOptions({
      "default.font-color": {
        value: "light",
        source: "theme.font",
      },
    }),
    new TextOptions({
      "default.text-wrap": "nowrap",
    }),
    new BackgroundOptions({
      "default.background-color": {
        value: "unset",
        source: "theme.background",
      },
    }, {
      "background-image": true,
    }),
  ],
  data() {
    return {
      ButtonType,
      ButtonSize,
      Icon,
      IconPosition,
      TextAlignment,
      ButtonAction,
      BorderRadius,
      LayoutHeight,
      LayoutWidth,
      LinkType,
    };
  },
};
